import React, { useContext } from 'react';

import { LayoutComponent_LocalLoader as LocalLoader } from 'ggApp/modules/layout';
import { PureTranslator } from 'ggApp/modules/translator';
import { CREDIT_CARD_MASK_SYMBOL } from 'ggApp/modules/payment/constants';

import PaymentIframeInput from 'ggApp/shared/common/Payment/PaymentGatewayList/CreditCard/NewFlow/PaymentIframeInput';
import getTkForPaymentLibraryError from 'ggApp/shared/common/Payment/PaymentGatewayList/CreditCard/NewFlow/paymentLibraryError';

import { ThemeContext } from 'styled-components';
import { SonntagIcon } from '@getgrover/ui';
import { lockIconPath } from 'ggApp/shared/icons/IconPaths';

import PaymentIframeInputUi from './PaymentIframeInputUi';

import {
    StyledForm,
    FormRow,
    FormRowItem,
    Input,
    iframeInputStyleObject,
    SubmitButton,
    ErrorText,
    Hint,
} from './styles';

const CreditCardFormUi = ({
    isFormLoading,
    isFormValid,
    paymentLibraryLoadFailed,
    handleSubmit,
    is3dsRequired,
    translationFunction,
    formErrorState,
    formState,
    paymentLibrary,
    handleIframeInputBlur,
    onInput,
    handleInputBlur,
    isFormSubmitting,
    tokenizationErrors,
    paymentMethodCreationFailed,
    threeDSWarningFlag,
}) => {
    const theme = useContext(ThemeContext);

    return (
        <>
            <LocalLoader active={isFormLoading}>
                {paymentLibraryLoadFailed && (
                    <ErrorText>
                        <PureTranslator tk="CREDIT_CARD_FORM_ERROR_FAILED_TO_LOAD_LIBRARY" />
                    </ErrorText>
                )}
            </LocalLoader>
            {!paymentLibraryLoadFailed && (
                <StyledForm isHidden={isFormLoading} onSubmit={handleSubmit}>
                    {!is3dsRequired && (
                        <>
                            <FormRow>
                                <PaymentIframeInput
                                    uiComponent={PaymentIframeInputUi}
                                    iframeInputStyleObject={iframeInputStyleObject}
                                    label={translationFunction(
                                        'NEW_CHECKOUT_PAYMENT_FORM_CARD_NUMBER',
                                    )}
                                    error={
                                        formErrorState.cardNumber &&
                                        translationFunction(formErrorState.cardNumber)
                                    }
                                    isEmpty={!formState.cardData.numberLength > 0}
                                    fieldType="number"
                                    iframeTargetId="myRandomId-cardNumber"
                                    paymentLibrary={paymentLibrary}
                                    onBlur={() => handleIframeInputBlur('cardNumber')}
                                />
                            </FormRow>

                            <Input
                                label={translationFunction(
                                    'NEW_CHECKOUT_PAYMENT_FORM_CARDHOLDER_NAME',
                                )}
                                error={
                                    formErrorState.cardholderName &&
                                    translationFunction(formErrorState.cardholderName)
                                }
                                hasError={!!formErrorState.cardholderName}
                                name="cardholderName"
                                type="text"
                                value={formState.cardholderName}
                                onChange={onInput}
                                onBlur={handleInputBlur}
                            />

                            <FormRow>
                                <FormRowItem>
                                    <Input
                                        label={translationFunction(
                                            'NEW_CHECKOUT_PAYMENT_FORM_EXPIRY_DATE',
                                        )}
                                        error={
                                            formErrorState.cardExpiration &&
                                            translationFunction(formErrorState.cardExpiration)
                                        }
                                        hasError={!!formErrorState.cardExpiration}
                                        name="cardExpiration"
                                        type="text"
                                        value={formState.cardExpiration}
                                        onChange={onInput}
                                        onBlur={handleInputBlur}
                                        maskProps={{
                                            mask: '99 / 99',
                                            maskChar: CREDIT_CARD_MASK_SYMBOL,
                                        }}
                                    />
                                </FormRowItem>
                                <FormRowItem>
                                    <PaymentIframeInput
                                        uiComponent={PaymentIframeInputUi}
                                        iframeInputStyleObject={iframeInputStyleObject}
                                        label={translationFunction('NEW_CHECKOUT_PAYMENT_FORM_CVC')}
                                        error={
                                            formErrorState.cardCVV &&
                                            translationFunction(formErrorState.cardCVV)
                                        }
                                        fieldType="cvv"
                                        isEmpty={!formState.cardData.cvvLength > 0}
                                        iframeTargetId="myRandomId-cvv"
                                        onBlur={() => handleIframeInputBlur('cardCVV')}
                                        paymentLibrary={paymentLibrary}
                                    />
                                </FormRowItem>
                            </FormRow>
                        </>
                    )}

                    {(is3dsRequired || threeDSWarningFlag) && (
                        <Hint>
                            <SonntagIcon
                                iconPath={lockIconPath}
                                color={theme.colors.secondary}
                                size="24"
                            />
                            <PureTranslator tk="CREDIT_CARD_3DS_WARNING_MESSAGE" />
                        </Hint>
                    )}

                    <SubmitButton
                        type="submit"
                        small
                        disabled={!isFormValid(formState) || isFormSubmitting}
                    >
                        <PureTranslator tk="CREDIT_CARD_FORM_SUBMIT_BUTTON_LABEL" />
                    </SubmitButton>
                </StyledForm>
            )}
            {tokenizationErrors &&
                tokenizationErrors.map((error) => (
                    <ErrorText key={error}>{getTkForPaymentLibraryError(error)}</ErrorText>
                ))}
            {paymentMethodCreationFailed && (
                <ErrorText>
                    <PureTranslator tk="CREDIT_CARD_FORM_FAILED_TO_SUBMIT" />
                </ErrorText>
            )}
        </>
    );
};

export default CreditCardFormUi;
